import { Alert, AlertDescription, AlertTitle } from '@govinity/ui/components/ui/alert';
import { EyeOff } from 'lucide-react';
import { useTranslations } from 'next-intl';

export function HiddenPageBanner() {
  const t = useTranslations('HiddenPageBanner');

  return (
    <Alert className="mx-auto mt-6 max-w-7xl" variant="warning">
      <EyeOff aria-hidden="true" />
      <AlertTitle>{t('title')}</AlertTitle>
      <AlertDescription>{t('description')}</AlertDescription>
    </Alert>
  );
}
